import { TFunction } from 'i18next';

import { CellRenderer, MainColumns } from '../../../../../../components/TableGrid';

export interface TableData {
  columns: MainColumns[];
  rows?: any[];
}

interface TransformMatrixData {
  data?: any[];
  tableFields: string[];
  translationsScope: string;
  t: TFunction;
}

export function transformMatrixData({
  data = [],
  tableFields,
  translationsScope,
  t,
}: TransformMatrixData): TableData {
  const columns: MainColumns[] = [
    {
      headerName: '',
      field: 'name',
      cellClass: 'borderedRight',
      minWidth: 320,
      pinned: 'left',
      suppressColumnsToolPanel: true,
    },
  ];
  const rows: any[] = [];

  data.forEach((item: any) => {
    columns.push({
      headerName: String(item.year),
      field: String(item.year),
      cellRenderer: CellRenderer.LinkOrNumberOrTextOrBoolean,
      minWidth: 100,
      flex: 1,
    });
    tableFields.forEach((rowName, index) => {
      if (!rows[index]) {
        rows[index] = {
          name: t(`${translationsScope}:${rowName}`),
        };
      }

      rows[index][String(item.year)] = item[rowName];
    });
  });

  columns.reverse();

  return { columns, rows };
}
